async function getCartData() {
  const url = "/cart.js";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    // console.log(json);
    const cartItemsCount = json.item_count;
    const cartDrawer= document.getElementById('CartDrawer');
    const cartDrawerHeader = cartDrawer.querySelector('.drawer__fixed-header');
    const cartDrawerCountDiv = cartDrawer.querySelector('.drawer_header__content .drawer_header_subcontent .js-cart-count');
    const cartDrawerFreeShippingTag = cartDrawer.querySelector('.drawer_header__content .free_shipping_tag');

    cartDrawerCountDiv.innerText = cartItemsCount;
    const styles = window.getComputedStyle(cartDrawerFreeShippingTag);
    const value = styles.getPropertyValue('display');
  
    if (value == 'none'){
      cartDrawerFreeShippingTag.style.display = 'flex';
    }
    
    if(cartItemsCount === 0 ){
      cartDrawerFreeShippingTag.style.display = 'none';
    }
  } catch (error) {
    console.error(error.message);
  }
}


document.addEventListener('DOMContentLoaded', function () {
  getCartData(); // Initial load

  // clear cart - start
document.addEventListener('click', function (event) {
  const clearCartBtn = event.target.closest('.clearCart');
  if (clearCartBtn) {
    event.preventDefault();

    const url = clearCartBtn.getAttribute("data-url");

    fetch(url + '.js', {
      method: 'POST'
    })
      .then(res => res.json())
      .then(cartData => {
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (typeof getCartData === 'function') {
          getCartData();
        }
        if (window.location.pathname === '/cart') window.location.reload();
      })
      .catch(err => {
        console.error('Clear cart failed:', err);
      });

  }
});


  // clear cart - end



  // delete individual cart item
  document.addEventListener('click', function (event) {
    const deleteBtn = event.target.closest('.delete_cart__item_buttons');
  
    if (deleteBtn) {
      event.preventDefault();
      event.stopPropagation();
  
      const cartItem = deleteBtn.closest('.cart__item');
      const itemKey = cartItem?.dataset.key;
  
      if (!itemKey) return;
  // console.log('key: ', itemKey);
    document.querySelector('.loading-spinner-cart').classList.add("active");
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      })
        .then(res => res.json())
        .then(async cart => {
          var cartDrawerPage = new theme.CartDrawer;
        if (deleteBtn.getAttribute('data-is-mainproduct')) { 
          const updates = {};
          let cartContent = cart;
            const filteredAddons = cartContent.items.filter(
              (item) => item.properties['_main_product_id'] && item.properties['_main_product_id'] == itemKey.split(':')[0]
            );

            filteredAddons.forEach((item) => {
              updates[item.key] = 0;
            });

            const params = {
              data: JSON.stringify({"updates": updates}),
              url: '/cart/update.js?t=' + Date.now(),
            };

            console.log(params, 'params');
            await theme.cart._updateCart(params).then((newCart) => {
              setTimeout(() => {
                // ✅ Update any external data layer
                if (window.location.pathname === '/cart' && JSON.parse(newCart).item_count == 0) {window.location.reload()};
                // if (typeof getCartData === 'function') {
                  //   getCartData();
                  // }
                  if( document.querySelector('.loading-spinner-cart')){
                    document.querySelector('.loading-spinner-cart').classList.remove("active");
                  }
                if(window.location.href.includes('/cart')){
                  document.dispatchEvent(new CustomEvent('cart:build'));
                }else{
                  var cartDrawer = new theme.CartDrawer;
                  cartDrawer.init();
                }
              },500)
            });
        }else{
          if (window.location.pathname === '/cart' && cart.item_count == 0) {window.location.reload()};
          // if (typeof getCartData === 'function') {
          //   getCartData();
          // }
         if( document.querySelector('.loading-spinner-cart')){
           document.querySelector('.loading-spinner-cart').classList.remove("active");
          }
          if(window.location.href.includes('/cart')){
                  document.dispatchEvent(new CustomEvent('cart:build'));
          }else{
            var cart = new theme.CartDrawer;
            cart.init();
          }
          // cartDrawerPage.init();
        }

          // ✅ Trigger the cart rebuild using your existing logic
          // document.dispatchEvent(new CustomEvent('cart:build'));

        })
        .catch(error => {
          console.error('Failed to remove cart item:', error);
        });
    }
  });
  // delete individual cart item


  // sales representative - start
  const selects = document.querySelectorAll('.mlveda_sales_representative_select');
  const hiddenInputs = document.querySelectorAll('.mlveda_sales_representative_input_hidden');

  // 🔁 1. Update all dropdowns + save to cart
  function updateSalesRep(value) {
    // Update all selects and hidden inputs
    selects.forEach(select => select.value = value);
    hiddenInputs.forEach(input => input.value = value);

    // Save to cart attribute
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          "Sales Representative": value
        }
      })
    }).catch(err => console.error('Error updating cart:', err));
  }

  // 🔁 2. Load current rep from cart and apply on page load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const rep = cart.attributes?.["Sales Representative"] || "";
      updateSalesRep(rep); // Apply current value on load
    })
    .catch(err => console.error('Error fetching cart:', err));

  // 🔁 3. Listen for changes on any dropdown
  document.addEventListener('change', function (event) {
    if (event.target.classList.contains('mlveda_sales_representative_select')) {
      updateSalesRep(event.target.value);
    }
  });

  // sales representative - end

});